@if (isOpen()) {
  <div class="side-drawer-backdrop" animate.leave="closing">
    <div
      #drawerContainer
      class="side-drawer-container d-flex justify-content-end"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
      (click)="close($event)"
    >
      <button class="align-self-start rounded-start py-1 px-0" aria-label="Close" (click)="close()">
        <mat-icon>arrow_right</mat-icon>
      </button>
      @if (contentTemplate(); as template) {
        <ng-container [ngTemplateOutlet]="template" />
      } @else {
        <ng-content />
      }
    </div>
  </div>
}
